exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "h1[data-v-fbfbe406]{margin:5px 0 10px}.el-row[data-v-fbfbe406]{margin-bottom:10px}", ""]);

// exports
